import React from 'react';

import { IconButton, Dropdown, ProgressIndicator } from 'office-ui-fabric-react';

import Stats from './filters/stats';
import TimeSeries from './filters/timeSeries';
import MultiAlt from './filters/multiAlt';

const filters = (props) => {
  const { plot, loadYears, filters, plotIndex, copiedFilter, favorites, toggleFavorites, toggleDatum, filtersFetched, editChartY, editTrace, setMap, userFavorites } = props;

  if(!filtersFetched){
    return <ProgressIndicator label='Loading Filters...'/>
  };

  plot.availableFilters.sources = filters.sources;
  plot.availableFilters.favorites = filters.favorites;

  const resolveFilter = (plot, plotIndex) => {
    switch(plot.appliedFilters.method){
      case 'Single Alternative': 
       return <Stats 
        editChartY={editChartY}
        loadYears={loadYears}
        setMap={setMap}
        editTrace={editTrace}
        favorites={favorites} 
        userFavorites={userFavorites}
        plot={plot} 
        plotIndex={plotIndex} 
        changeFilter={props.changeFilter} 
        applyFilters={props.applyFilters} 
        setPlotData={props.setPlotData} 
        buildStatsPlot={props.buildStatsPlot}/>;

      case 'Time Series': 
        return <TimeSeries 
          loadYears={loadYears}
          editChartY={editChartY} 
          setMap={setMap}
          toggleDatum={ toggleDatum }
          editTrace={editTrace}
          favorites={favorites} 
          userFavorites={userFavorites}
          plot={plot} 
          plotIndex={plotIndex} 
          changeFilter={props.changeFilter} 
          applyFilters={props.applyFilters}/>;

      case 'Multiple Alternative': 
        return <MultiAlt
          loadYears={loadYears}
          editChartY={editChartY}
          setMap={setMap}
          toggleDatum={ toggleDatum } 
          favorites={favorites} 
          userFavorites={userFavorites}
          editTrace={editTrace}
          plot={plot} 
          plotIndex={plotIndex} 
          changeFilter={props.changeFilter} 
          applyFilters={props.applyFilters} 
          setPlotData={props.setPlotData} 
          buildStatYear={props.buildStatYear}/>

      default:
        return null
    }
  };

  return (
    <div className='filters pivot-body'>
      <div className='filter-wrapper'>
        <div className='filter-col'>
          <Dropdown
            placeHolder="Select a Query Method"
            id="type-dropdown-filter"
            selectedKey={plot.appliedFilters.method}
            onChange={(e, option) => props.changeFilter({method: option.text}, plotIndex, 'method')}
            options={ plot.availableFilters.methods.map((each) => ({key: each, text: each})) }
          />
          {
            resolveFilter(plot, plotIndex)
          }    
        </div>
        <div className='filter-controls'>
          <IconButton
            className='favorite'
            iconProps={{ iconName: favorites ? 'FavoriteStarFill' : 'FavoriteStar', style: { color: favorites ? '#0078d4' : '#666', fontSize: 12 } }}
            title="Filter Favorites"
            ariaLabel="Filter Favorites"
            onClick={() => {
              toggleFavorites(plotIndex, !favorites)
            }}
          />
          <IconButton
            className='clear-chart'
            iconProps={{ iconName: 'EraseTool', style: { color: '#666', fontSize: 12 } }}
            title="Erase Data"
            ariaLabel="Erase Data"
            onClick={() => {
              props.clearFilters(plotIndex);
              props.setPlotData([], plotIndex);
            }}
          />
          <IconButton
            className='copy'
            iconProps={{ iconName: 'Copy', style: { color: '#666', fontSize: 12 } }}
            title="Copy Filters"
            ariaLabel="Copy Filters"
            onClick={() => props.copyFilter({...plot.appliedFilters})}
          />
          <IconButton
            className='paste'
            disabled={ !copiedFilter }
            iconProps={{ iconName: 'Paste', style: { color: '#666', fontSize: 12 } }}
            title="Paste Filters"
            ariaLabel="Paste Filters"
            onClick={() => props.pasteFilter(copiedFilter, plotIndex)}
          />
        </div>
      </div>
    </div>
  )
};

export default filters;


// WEBPACK FOOTER //
// ./src/components/panel/items/filters.js